import { api } from '@/services/backend/http-client';
import { IsicData } from './types';

export const getIsicDataByCodeOrName = async (codeOrName: string): Promise<IsicData[]> => {
  const response = await api.get<IsicData[]>(`/isic/search?codeOrName=${codeOrName}`);
  return response.data;
};

export const getIsicDataByCode = async (code: string): Promise<IsicData> => {
  const response = await api.get<IsicData>(`/isic/${code}`);
  return response.data;
};
